import type { FetchQueryOptions } from "@tanstack/react-query"
import { queryClient } from "./queryClient"
import type { FnBase, FnParams, FnReturn } from "./types"
import { getArgs } from "./utils/getArgs"

type Options<Fn extends FnBase> = FetchQueryOptions<FnReturn<Fn>>
type Return = Promise<void>

export type PrefetchQuery<Fn extends FnBase> = (
  args: FnParams<Fn>,
  options?: Options<Fn>
) => Return

export const getPrefetchQuery = (
  fn: FnBase,
  path: string[]
): PrefetchQuery<FnBase> => {
  return (...input) => {
    const { args, rest } = getArgs(input)
    const key = [...path, ...args]
    return queryClient.prefetchQuery({
      ...rest,
      queryKey: key,
      queryFn: () => fn(...args),
    })
  }
}
